import React from 'react';
import { Box, Stack, ButtonBase, Typography, useTheme } from '@mui/material';
import CompressRoundedIcon from '@mui/icons-material/CompressRounded';
import OpenInFullRoundedIcon from '@mui/icons-material/OpenInFullRounded';
import { useTranslation } from 'react-i18next';

import { useSettingsContext } from '../../../../setting/SettingsContext';
import SectionLabel from './SectionLabel';

const OPTIONS = [
    { value: false, icon: CompressRoundedIcon, en: 'Default', ar: 'الافتراضي' },
    { value: true, icon: OpenInFullRoundedIcon, en: 'Stretch', ar: 'موسّع' },
];

/**
 * Toggle between the default `xl`-capped content width and a full-bleed
 * layout that uses the entire viewport. Reads/writes themeStretch on
 * the SettingsContext; WrapperSection consumes it.
 */
const StretchOptions = () => {
    const theme = useTheme();
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');

    const { themeStretch, onToggleStretch } = useSettingsContext();

    const handlePick = (val) => {
        // onToggleStretch already flips between the two states; only fire it
        // when the user actually picks a different value than what's active.
        if (val !== themeStretch) onToggleStretch();
    };

    return (
        <Box>
            <SectionLabel>{isArabic ? 'العرض' : 'Stretch'}</SectionLabel>
            <Stack direction="row" spacing={1.5}>
                {OPTIONS.map(({ value, icon: Icon, en, ar }) => {
                    const selected = themeStretch === value;
                    return (
                        <ButtonBase
                            key={String(value)}
                            onClick={() => handlePick(value)}
                            sx={{
                                flex: 1,
                                flexDirection: 'column',
                                gap: 0.75,
                                p: 1.5,
                                borderRadius: 2,
                                border: `1.5px solid ${
                                    selected ? theme.palette.primary.main : theme.palette.divider
                                }`,
                                bgcolor: selected
                                    ? `${theme.palette.primary.main}12`
                                    : 'transparent',
                                color: selected ? theme.palette.primary.main : 'text.primary',
                                transition: 'all 0.2s',
                                '&:hover': {
                                    borderColor: theme.palette.primary.main,
                                    bgcolor: `${theme.palette.primary.main}08`,
                                },
                            }}
                        >
                            <Icon fontSize="small" />
                            <Typography sx={{ fontSize: 12, fontWeight: 600 }}>
                                {isArabic ? ar : en}
                            </Typography>
                        </ButtonBase>
                    );
                })}
            </Stack>
        </Box>
    );
};

export default StretchOptions;
